import React, { FC } from 'react';

// Styles
import './country-option.scss';

// Modals
import { ICountry } from '../../../interfaces/core.interfaces';

type TCountryOptionProps = {
  country: ICountry;
};

export const CountryOption: FC<TCountryOptionProps> = (
  { country: { flag, name } }: TCountryOptionProps
) => {

  return (
    <div className="country-option">
      <img className="country-option--img" src={ flag } alt={ name }/>
      <span className="country-option--name">{ name }</span>
    </div>
  );
}
